import React from 'react';
import { FilterTextField } from './styles';

const TableFilter = ({ name, filter, setFilter, maxWidth }) => {
    const onChangeFilter = event => {
        setFilter({ ...filter, [name]: event.currentTarget.value, page: 0 }, 'FILTER_ACTIVE');
    };

    return (
        <FilterTextField
            label="Filter"
            style={{ width: maxWidth + 'px' }}
            variant="outlined"
            value={filter[name]}
            onChange={onChangeFilter}
        />
    );
};
export default TableFilter;
